export default "__VITE_ASSET__BRg_O_Uu__"